import { Component } from 'react';
import { Trans } from 'react-i18next';

import { BaseLink } from '../BaseLink';
import * as styles from './ErrorBoundary.module.css';

import type { ErrorInfo, ReactNode } from 'react';

export class ErrorBoundary extends Component<{children: ReactNode}> {
  public state = {
    hasError: false,
  };

  public static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary caught an error', error, info);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div>
          <h1 className={styles.message}>
            <Trans i18nKey='common:error_message' />
          </h1>
          <div className={styles.link}>
            <BaseLink href='/'>
              <Trans i18nKey='common:back_to_homepage' />
            </BaseLink>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
